// This feature has no effect in the frontend
// Will be checked in the backend
export const ConvoMatchFeature = {
    name: 'Content Convo Match',
    key: 'convomatch',
    config: {
    }
}